// Date helpers shared by the timesheet's hours and materials tables.
// Local dates only: toISOString() would shift to UTC and can land on the wrong day or week.

export function ymd(date) {
  return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
}

export function parseYmd(value) {
  const [y, m, d] = String(value).slice(0, 10).split('-').map(Number);
  return new Date(y, m - 1, d);
}

export function addDays(date, days) {
  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  d.setDate(d.getDate() + days);
  return d;
}

// Weeks run Monday to Sunday and are stored by their Sunday.
export function weekEndingFor(date) {
  return ymd(addDays(date, (7 - date.getDay()) % 7));
}
